import {combineReducers, configureStore} from '@reduxjs/toolkit';
import { persistStore, persistReducer,  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER, } from 'redux-persist';
import storage from 'redux-persist/lib/storage'
import userReducer from './user/userSlice';
import pinReducer from './pin/pinSlice';
import themeReducer from './theme/themeSlice';
import tendanceReducer from './tendances/tendanceSlice'
import langReducer from './lang/langSlice'


const persistConfig = {
  key: 'root',
  storage,
}
const rootReducer = combineReducers({
  current_user: userReducer,
  // PIN: deactivate
  // pin : pinReducer,
  theme : themeReducer,
  tendance : tendanceReducer,
  lang:langReducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

let store = configureStore({
  reducer : persistedReducer,
  /*https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data*/
  middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),

});
let persistor = persistStore(store)

export { store, persistor };
